let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7EgS6")).then(() => parcelRequire('3KifV'));